<section class="fee-overview-container">
  <div class="box-one">
    <h6>Collection by Class</h6>

    <small>Amount collected vs. total billed per class</small>

    <div class="class-fees">
      @for (c of classFeeStats(); track $index) {
        <div class="class-fee">
          <div class="class-data">
            <p>{{ c?.className ?? 'N/A' }}</p>

            <div>
              <p class="billed">GH₵{{ Helpers.formatAmount(c?.totalPaid) }} / GH₵{{ Helpers.formatAmount(c?.totalBilled) }}</p>
              <p class="amount-percent">{{ c?.percentagePaid ?? 0 | number: '1.0-0' }}%</p>
            </div>
          </div>

          <div class="class-range"><div [style.width.%]="c?.percentagePaid ?? 0"></div></div>
        </div>
      } @empty {
        @if (!isLoading()) {
          <div class="empty-state">
            <p>No collection data yet</p>
            <small>Payments collected per class will appear here once available.</small>
          </div>
        }
      }
    </div>
  </div>

  <div class="box-two">
    <div class="payment-status">
      <h6>Payment Status</h6>

      <div class="payment-status-container">
        <div>
          <div class="payment-row">
            <p>Paid</p>

            <div class="paid-number">
              <p>{{ studentFeeStatus()?.paid?.total ?? 0 }}</p>
              <small>{{ studentFeeStatus()?.paid?.percentage ?? 0 | number: '1.0-0' }}%</small>
            </div>
          </div>

          <div class="payment-range"><div [style.width.%]="studentFeeStatus()?.paid?.percentage ?? 0" class="paid"></div></div>
        </div>

        <div>
          <div class="payment-row">
            <p>Partial</p>

            <div class="paid-number">
              <p>{{ studentFeeStatus()?.partiallyPaid?.total ?? 0 }}</p>
              <small>{{ (studentFeeStatus()?.partiallyPaid?.percentage ?? 0) | number: '1.0-0' }}%</small>
            </div>
          </div>

          <div class="payment-range"><div [style.width.%]="studentFeeStatus()?.partiallyPaid?.percentage ?? 0" class="partial"></div></div>
        </div>

        <div>
          <div class="payment-row">
            <p>Unpaid</p>

            <div class="paid-number">
              <p>{{ studentFeeStatus()?.unpaid?.total ?? 0 }}</p>
              <small>{{ studentFeeStatus()?.unpaid?.percentage ?? 0  | number: '1.0-0' }}%</small>
            </div>
          </div>

          <div class="payment-range"><div [style.width.%]="studentFeeStatus()?.unpaid?.percentage ?? 0" class="unpaid"></div></div>
        </div>

        <div>
          <div class="payment-row">
            <p>Waived</p>

            <div class="paid-number">
              <p>{{ studentFeeStatus()?.waived?.total ?? 0 }}</p>
              <small>{{ (studentFeeStatus()?.waived?.percentage ?? 0) | number: '1.0-0' }}%</small>
            </div>
          </div>

          <div class="payment-range"><div [style.width.%]="studentFeeStatus()?.waived?.percentage ?? 0" class="waived"></div></div>
        </div>

        <div>
          <div class="payment-row">
            <p>Overdue</p>

            <div class="paid-number">
              <p>{{ studentFeeStatus()?.overdue?.total ?? 0 }}</p>
              <small>{{ studentFeeStatus()?.overdue?.percentage ?? 0 }}%</small>
            </div>
          </div>

          <div class="payment-range"><div [style.width.%]="studentFeeStatus()?.overdue?.percentage ?? 0" class="overdue"></div></div>
        </div>

        <div>
          <div class="payment-row">
            <p>Cancelled</p>

            <div class="paid-number">
              <p>{{ studentFeeStatus()?.cancelled?.total ?? 0 }}</p>
              <small>{{ studentFeeStatus()?.cancelled?.percentage ?? 0 | number: '1.0-0' }}%</small>
            </div>
          </div>

          <div class="payment-range"><div [style.width.%]="studentFeeStatus()?.cancelled?.percentage ?? 0" class="cancelled"></div></div>
        </div>

      </div>
    </div>

    <div class="recent-payments">
      <h6>Recent Payments</h6>

      <div class="activities">
        @for (a of recentPayments(); track $index) {
          <div class="activity">
            <div>
              <p>{{ a?.student?.name ?? 'N/A' }}</p>
              <small>{{ Helpers.formatDate((a?.date ?? '')) }}</small>
            </div>

            <p class="activity-time">GH₵{{ Helpers.formatAmount(a?.amount) }}</p>
          </div>
        } @empty {
          @if (!isLoading()) {
            <div class="empty-state">
              <p>No recent payments yet</p>
              <small>Completed payments will show up here once recorded.</small>
            </div>
          }
        }
      </div>
    </div>

  </div>
</section>
